'use client';

import { cn } from '@/lib/utils';
import { Example } from '@/types/Example';
import ExampleSimpleRow from './ExampleSimpleRow';

export interface CommandCatalogueProps {
  cheats: Example[];
  showAsGrid: boolean;
  showDifficulty: boolean;
  editable: boolean;
}

const CommandCatalogue = (props: CommandCatalogueProps) => {
  const { cheats, showAsGrid = false, editable } = props;

  return (
    <div
      className={cn(
        `grid w-full grid-cols-1 items-center justify-center gap-2 sm:grid-cols-2 sm:gap-4`,
        {
          'sm:grid-cols-1': !showAsGrid,
        },
        'print:grid-cols-1',
      )}
    >
      {cheats.map((cheat) => (
        <ExampleSimpleRow
          key={cheat.example}
          showShortDescription
          example={cheat}
          className="h-full"
          editable={editable}
        />
      ))}
    </div>
  );
};

export default CommandCatalogue;
